export default __webpack_public_path__ + "static/2-fe3bc9713189734f98f28b49550187b6.png";